import React from "react";

import { WechatOutlined, MobileTwoTone } from "@ant-design/icons";

import { Popover, Image } from "antd";

import MobileQrcode from "assets/qrcode/mobile.png";
import WeappQrcode from "assets/qrcode/weapp.jpg";
import styled from "styled-components";

interface IPromotionItemProps {
  title: string;
  image: string;
  icon: React.ReactNode;
}

const options: IPromotionItemProps[] = [
  {
    title: "扫描二维码在移动端使用",
    image: MobileQrcode,
    icon: <MobileTwoTone style={{ fontSize: 24 }} />,
  },
  {
    title: "扫描小程序码使用小程序",
    image: WeappQrcode,
    icon: <WechatOutlined style={{ fontSize: 24, color: "#1AAD19" }} />,
  },
];

const ContentContainer = styled.section`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const IconContainer = styled.section`
  display: flex;
  align-items: center;
  cursor: pointer;
  & + & {
    margin-left: 12px;
  }
`;

const PromotionItem: React.FC<IPromotionItemProps> = ({
  title,
  image,
  icon,
}) => {
  const Content = (
    <ContentContainer>
      <Image width={150} height={150} src={image} />
    </ContentContainer>
  );
  return (
    <Popover
      content={Content}
      trigger="hover"
      title={title}
      placement="bottomRight"
    >
      <IconContainer>{icon}</IconContainer>
    </Popover>
  );
};

const PromotionContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Promotion: React.FC = () => {
  return (
    <PromotionContainer>
      {options.map((item) => (
        <PromotionItem {...item} />
      ))}
    </PromotionContainer>
  );
};

export default Promotion;
